import React, { useState } from "react";
import { useAgencyInfo } from "../../../context/agency";
import { INTEGRATION_Data } from "./Constant";
import Select from 'react-select'
import { Button } from "reactstrap";
import { useAppServices } from "../../../hook/services";
interface PropsType {
  users: any[]
}
const DefaultUsers = ({ users }: PropsType) => {
  const [agency] = useAgencyInfo()
  const Service = useAppServices()
  const userOptions = users.map((item) => ({
    ...item,
    label: item.username,
    value: item.id,
  }))
  const handleSubmit = async (e: any) => {
    e.preventDefault()
    const payload = {
      default_user: e.target.default_user.value,
      _id: agency?._id
    }
    console.log(payload, 'payload')
    const { response } = await Service.agency.update({ payload })
    if (response) {
    }
  }
  return (
    <div className="accordion-body" >
      <form onSubmit={handleSubmit}>
        <div>

          <p className="text-muted mb-1" style={{ fontSize: '13px' }}>users</p>
          <Select defaultValue={userOptions?.filter((item) => item.value == agency?.default_user)[0]} options={userOptions} name="default_user" />
        </div>
        <div className="mt-4" style={{ display: 'flex', justifyContent: 'flex-end' }}>

          <Button type="submit" color="success" >
            Save
          </Button>
        </div>
      </form>
    </div>
  );
};

export default DefaultUsers;
